import React from 'react';
import { withRouter } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { trakrefFontFamily, isDesktop } from '../utils';
import AccountMenuButton from './AccountMenuButton';
import useNavigate from '../hooks/useNavigate';

import './NavBar/NavMenu.css';
import UserInfo from '../UserInfo';
import { HoverColor, lightBlue, toolTipBlue, trakrefBlue, trakrefDisabledBlue } from '../color_utils';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
const AccountMenu = ({
    logout,
    userData,
    closeDrawer,
    instances,
}) => {
    const navigate = useNavigate({
        pageName:'AccountMenu'
    });

    const accountMenuData = [
        isDesktop && {
            title: 'Account Details',
            description: "Manage your account and users, view your documents.",
            icon: '/images/dials.png',
            onClick: () => navigate.push("/Account")
        },
        isDesktop && UserInfo.isSystemAdministrator() && {
            title: 'Geek Command Center',
            description: "Manage the access and level  of responsibility of all users.",
            icon: '/images/joystick.png',
            onClick: () => navigate.push("/GeekCommandCenter")
        },
        {
            title: 'Your Profile',
            description: "Change your password and your details.",
            icon: '/images/happy.png',
            onClick: () => navigate.push("/Profile")
        },
        {
            title: 'Help',
            description: "Find product tutorials, register for upcoming training sessions.",
            icon: '/images/sos.png',
            onClick: () => window.open(" https://trakrefv4.zendesk.com/", '_blank')
        },
        {
            title: 'Log Out',
            description: "We hope to see you soon!",
            icon: '/images/handwave.png',
            onClick: () => {
                localStorage.removeItem("lastPageView")
                localStorage.removeItem("lastInstanceId")
                logout()
            }
        },
    ].filter(Boolean);

    return (
        <Box
            sx={{ width: {xs: 320, sm: 450} }}
            role="presentation"
        >
            <Box pl={3} pb={2} pt={{ md: 6, lg: 4}} >
                <Typography sx={{ font: trakrefFontFamily, color: '#000', fontSize: {xs: '14px', md: '18px'} }}>
                    {`${userData.firstName} ${userData.lastName}`}
                </Typography>
            </Box>
            {(instances.length > 1) && <Box
                onClick={
                    () => {
                        navigate.push("/SelectAccount");
                    }
                }
                sx={{
                    marginX: "16px",
                    marginY: "4px",
                    marginBottom: "16px",
                    paddingY: "4px",
                    borderRadius: "4px",
                    border: `1px solid ${trakrefDisabledBlue}`,
                    justifyContent: 'center',
                    display: 'flex',
                    gap: '8px',
                    cursor: 'pointer',
                    ":hover": { backgroundColor: HoverColor },
                }}
            >
                <CompareArrowsIcon sx={{
                    color: trakrefBlue
                }} />
                <Typography
                    sx={{
                        color: trakrefBlue,
                        fontFamily: trakrefFontFamily,
                    }}
                >
                    Switch Account
                </Typography>
            </Box>}
            {accountMenuData.map((item) => (
                <AccountMenuButton
                    title={item.title}
                    description={item.description}
                    icon={item.icon}
                    onClick={() => {
                        item.onClick();
                        closeDrawer();
                    }}
                />
            ))}
        </Box>
    );
};

export default withRouter(AccountMenu);
